/**
 * Normaliza texto de notificação em minúsculas com ponto final e início maiúsculo
 * @param value Texto da mensagem
 */
export function formatNotificationMessageText(value: string | null | undefined): string {
  const normalized = (value ?? '').trim().toLocaleLowerCase('pt-BR');

  if (!normalized) {
    return '';
  }

  const withPeriod = normalized.endsWith('.') ? normalized : `${normalized}.`;

  return withPeriod.charAt(0).toLocaleUpperCase('pt-BR') + withPeriod.slice(1);
}
